class StepLearningEngagementService {
    constructor($http, $state, $q, $mdDialog, $mdToast) {
        this.$http = $http;
        this.$state = $state;
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;

        this.setLearningEngagementData = function(evalId, evaluationData, isMini) {
            let stateMode = isMini ? 'mini' : 'evaluation';
            return this.$http({
                method: 'post',
                url: `/api/${stateMode}/${evalId}/learning_engagement`,
                data: evaluationData,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => self.$q.reject(error));
        };
    };

    getAspects() {
        var self = this;
        return this.$http({
            method: 'GET',
            url: '/api/learning_engagement/aspect',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            self.aspectsNumber = response.data.length;
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    getLearningEngagementsSummary(id) {
        var self = this;
        return this.$http({
            method: 'GET',
            url: '/api/evaluation/' + id + '/learning_engagements/summaries',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    saveExportedAnswers(evaluationId, exportData) {
        let self = this;
        return this.$http({
            method: 'post',
            url: `/api/mini/${evaluationId}/learning_engagement_summary`,
            data: exportData,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        }).then((res => res.data), (error) => self.$q.reject(error));
    };

    saveAnswers(evalId, answersData, currAspectNr, isMini, redirect) {
        let self = this;
        let stateMode = isMini ? 'mini' : 'evaluation';
        currAspectNr = parseInt(currAspectNr);
        self.setLearningEngagementData(evalId, answersData, isMini)
            .then(() => {
                self.$mdToast.show(
                    self.$mdToast.simple()
                        .textContent('Your data has been saved sucessfuly')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass("success-toast")
                );
                const isLastIndex = currAspectNr === self.aspectsNumber - 1;
                self.displayPromptOnRedirct = false;
                if (redirect) {
                    if (isLastIndex) {
                        self.$state.go(`${stateMode}.conclusions`, {id: evalId}, {reload: true});
                    } else {
                        self.$state.go(`${stateMode}.learningEngagement.aspect`, {id: evalId, aspectNr: currAspectNr + 1}, {reload: true});
                    }
                }
            })
            .catch(err => {
                self.$mdDialog.show(
                    self.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent: `Your data has not been saved. Please try again.`,
                        ok: 'OK'
                    })
                );
                return self.$q.reject(err);
            });
    }
}

export default StepLearningEngagementService;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/services/stepLearningEngagementService.js